module.exports = __webpack_public_path__ + "assets/Chord3Detailed.c5cf3b54490ae2d0b9053e8838d93cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Chord3Detailed.png
// module id = 479
// module chunks = 0